export default __webpack_public_path__ + "static/media/WhatsApp  icon Menu.6e066076.svg";